import { request } from "@/App/api/request";
import { HoursHistoryListResults } from "../interface";
import { useContext } from "react";
import { AuthenticationContext, MemberEligibilityContext } from "@/App/context";
import { useQuery } from "@tanstack/react-query";

export const getEligibilityHourBankDatasource = async (authToken: string) => {
  return request<{}, HoursHistoryListResults>({
    endpoint: "/eligibility/member_hours/list",
    body: {},
  }, authToken);
};

export const useGetEligibilityHourBankDatasourceQuery = () => {
  const { memberEligibility } = useContext(MemberEligibilityContext);
  const { getAuthToken } = useContext(AuthenticationContext);

  return useQuery({
    queryFn: async () => {
      return getEligibilityHourBankDatasource(await getAuthToken());
    },
    queryKey: ["eligibilityMemberHoursBank", memberEligibility.plan.id],
  });
};
